export default "__VITE_ASSET__iLyQVsUY__"